import {
  AppBar,
  Box,
  Fade,
  MenuItem,
  Paper,
  Popper,
  Tab,
  Tabs,
  Toolbar,
} from "@mui/material";
import React, { useContext, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { SearchBar } from "../../utils/SearchBar";
import Axios from "../../../../services/axios";
import { DbUser, InsightsCtx } from "../../../../interfaces";
import { useHistory, useLocation } from "react-router-dom";
import { ITab } from "../../../../pages/v2/InsightsSummaryPage";
import { HandleDataLayer } from "../../../../Helpers";
import { InsightsContext } from "../../../../context/InsightsContext";

const useStyles = makeStyles((theme) => ({
  tabs: {
    "& .MuiTab-root": {
      color: theme.palette.text.primary,
      fontSize: 18,
    },
  },
  root: {
    height: 72,
    boxSizing: "border-box",
    paddingLeft: 32,
    paddingRight: 32,
    maxWidth: "1280px",
    width: "100%",
  },
  tab: {
    height: 72,
  },
}));

interface InsightsTabMenuProps {
  availableTabs: ITab[];
  value: number;
  handleChange: (e: any, tab: ITab) => void;
  classId: number;
}

export const SummaryTabMenu = (props: InsightsTabMenuProps) => {
  const { availableTabs, value, handleChange, classId } = props;
  const insightsCtx = useContext(InsightsContext) as InsightsCtx;
  const history = useHistory();
  const location = useLocation();
  const [searchText, setSearchText] = React.useState<string>("");
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [studentList, setStudentList] = React.useState<DbUser[]>([]);
  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSearchText(event.target.value);
    if (event.target.value === "") {
      setOpen(false);
      setAnchorEl(null);
      return;
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  useEffect(() => {
    if (searchText === "") {
      return;
    }
    // add debouncing
    const timer = setTimeout(() => {
      HandleDataLayer(
        "search",
        "type",
        "main search",
        "main content",
        "sticky navbar",
        searchText,
        "onenter"
      );
      const getStudents = async () => {
        try {
          let res = await Axios.get(`/insights/class/${classId}?search=${searchText}`);
          setStudentList(res.data);
          setOpen(true);
        } catch (e) {
          console.log(e);
        }
      };

      getStudents();
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [searchText, classId]);

  // clear search text on leaving student summary
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!params.get("studentName")) {
      setSearchText("");
    }
  }, [location]);

  const handleSearchResultClick = (student: DbUser) => {
    setSearchText(student.full_name);
    setOpen(false);
    setAnchorEl(null);
    insightsCtx.setLastClassId(Number(classId));
    history.push({
      // pathname: `/student/${student.id}/insights`,
      pathname: `/insights/class/${classId}/student/${student.id}/summary`,
      // pathname: `/insights/student/${student.id}/summary`,
      //search: `?studentId=${student.id}&studentName=${student.full_name}`,
    });
  };

  return (
    <AppBar
      sx={{ alignItems: "center", borderBottom: `2px solid #dedede` }}
      position="sticky">
      <Toolbar
        disableGutters
        className={classes.root}
        tabIndex={-1}
        sx={{ display: "flex", flexDirection: "row" }}>
        <Box sx={{ flexGrow: 0 }}>
          <Tabs className={classes.tabs} value={value} aria-label="basic tabs example">
            {availableTabs.map((tab, index) => {
              if (tab.isHidden) {
                return null;
              }
              return (
                <Tab
                  className={classes.tab}
                  key={tab.id}
                  label={tab.label}
                  value={index}
                  onClick={(e) => {
                    HandleDataLayer(
                      "link",
                      "click",
                      "internal link",
                      "main content",
                      "sticky navbar",
                      tab.label,
                      "onclick"
                    );
                    handleChange(e, tab);
                  }}
                />
              );
            })}
          </Tabs>
        </Box>
        <Box sx={{ display: "flex", gap: "16px", flexGrow: 1 }}>
          <SearchBar
            sx={{ marginLeft: "auto" }}
            searchText={searchText}
            onSubmit={() => {}}
            onInputChange={handleInputChange}
            HandleDataLayer={() => {}}
            placeholder={"Search students"}
            hideSearchButton={true}
          />
          {anchorEl && (
            <Popper
              id={"popper-d"}
              open={open}
              placement={"bottom"}
              anchorEl={anchorEl}
              sx={{ marginTop: "10px !important", zIndex: "9999999 !important" }}
              transition>
              {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={350}>
                  <Paper
                    sx={{ maxWidth: "390px", minWidth: "390px" }}
                    variant={"outlined"}>
                    {studentList.length > 0 &&
                      studentList.map((student: DbUser) => {
                        return (
                          <MenuItem
                            key={student.id}
                            onClick={() => {
                              handleSearchResultClick(student);
                            }}
                            sx={{ padding: "8px 16px" }}>
                            {student.full_name}
                          </MenuItem>
                        );
                      })}
                    {studentList.length === 0 && (
                      <MenuItem sx={{ padding: "8px 16px" }}>No results found</MenuItem>
                    )}
                  </Paper>
                </Fade>
              )}
            </Popper>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};
